import { memo } from 'react';
import SVGBase, { type SVGComponentProps } from './SVGBase';

const path = <path d="M12.667 22.667l6.667-6.667-6.667-6.667z" />;

function ArrowRight({
  className,
  title = 'Arrow Right',
}: SVGComponentProps) {
  return (
    <SVGBase
      className={className}
      labeledBy="arrow-right-svg"
      path={path}
      title={title}
    />
  );
}

export default memo(ArrowRight);
